module.exports = __webpack_public_path__ + "img/home_yunfeishixiaochaxun.53487ac.png";